
<template>
<!-- 家长端微信小程序配置业务域名需要的校验文件 -->
  <div class="">1c12b303be026647b0853067b9b1d9ac</div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>
